const OBSERVATION_DISMISSED_PREFIX = "teacher_observation_dismissed_v1";

const getStorageKey = (userId) => {
  const normalized = String(userId || "").trim().toLowerCase();
  if (!normalized) return null;
  return `${OBSERVATION_DISMISSED_PREFIX}:${normalized}`;
};

const toIdList = (value) => {
  if (!Array.isArray(value)) return [];
  return value.map((item) => String(item || "").trim()).filter(Boolean);
};

export const getDismissedObservationIds = (userId) => {
  if (typeof window === "undefined") return new Set();
  const key = getStorageKey(userId);
  if (!key) return new Set();
  const raw = window.localStorage.getItem(key);
  if (!raw) return new Set();
  try {
    const parsed = JSON.parse(raw);
    return new Set(toIdList(parsed));
  } catch (_error) {
    return new Set();
  }
};

export const setDismissedObservationIds = (userId, ids) => {
  if (typeof window === "undefined") return;
  const key = getStorageKey(userId);
  if (!key) return;
  const rows = Array.from(ids || [])
    .map((item) => String(item || "").trim())
    .filter(Boolean);
  window.localStorage.setItem(key, JSON.stringify(rows));
};

export const dismissObservation = (userId, observationId) => {
  const next = getDismissedObservationIds(userId);
  const normalizedId = String(observationId || "").trim();
  if (!normalizedId) return next;
  next.add(normalizedId);
  setDismissedObservationIds(userId, next);
  return next;
};

export const undismissObservation = (userId, observationId) => {
  const next = getDismissedObservationIds(userId);
  const normalizedId = String(observationId || "").trim();
  if (!normalizedId) return next;
  next.delete(normalizedId);
  setDismissedObservationIds(userId, next);
  return next;
};
